<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [ reactiveProp ],
  props: [ 'chartData' ],
  name: 'weeklySales',
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          //display: true,
          //position: 'right',
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            },
          },
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: '日付'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 2000000,
              callback: function(label) {
                label = parseInt(label) / 10000
                return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
            },
            scaleLabel: {
              display: true,
              labelString: '万円（税込）'
            }
          }]
        },
        elements: {
          line: {
            //tension: 0,
          },
        },
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },

}
</script>
